import { DatePipe, NgIfContext, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { IUserData } from '@resident-nx/shared';
import { AvatarSizeEnum, AvatarWebComponent } from '@resident-nx/web/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AvatarWebComponent, NgTemplateOutlet, DatePipe, TranslateModule],
})
export class ProfileDetailsWebComponent {
  @Input() userData: IUserData;
  @Input() noData: TemplateRef<NgIfContext<string>>;
  public avatarSize = AvatarSizeEnum;
}
